import { toastError } from "../../../actions/toast";
import { GEO_SHAPE_TYPE, uuid } from "../../../helpers/common";
import store from "../../../store";

export class GeoFileImporter {
  init(drawingTools) {
    this.drawingTools = drawingTools;
    this.title = { name: 'Untitled', type: 2, disableType: false, cropName: "", startDate: null };
  }

  async importFile(data) {
    const shapeObj = this.drawingTools.getShapeInstance();
    if (!data) return;
    const { properties } = data;
    const fileName = data.fileName ? data.fileName : (properties && properties.FieldName) ? properties.FieldName : null;
    if (fileName && fileName.length > 0 && this.title.name === "Untitled") {
      this.drawingTools.emit("title_save", { title: this.title });
    }

    const addShapes = (geoData) => {
      const { geometry, properties } = geoData;
      const shapeId = uuid();
      const options = {};
      if (geometry.type === "Polygon") {
        const geoProperties = {
          strokeColor: '#FFF',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03FF6D33',
          fillOpacity: 1,
          zIndex: 1
        };

        if (properties.stroke) geoProperties.strokeColor = properties.stroke;
        if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
        if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];
        if (properties.fill) geoProperties.fillColor = properties.fill;
        if (properties["fill-opacity"]) geoProperties.fillOpacity = properties["fill-opacity"];

        const location = geometry.coordinates[0].map(e => ({ lng: e[0], lat: e[1] }));

        options.properties = { ...geoProperties, others: { ...properties } };
        options.location = location;
        options.type = GEO_SHAPE_TYPE.POLYGON;
      } else if (geometry.type === "Point") {
        const location = {
          lng: geometry.coordinates[0],
          lat: geometry.coordinates[1]
        }
        options.location = [location];
        options.properties = {
          icon: null,
          zIndex: 1,
          others: { ...properties }
        };
        options.type = GEO_SHAPE_TYPE.MARKER;
      } else if (geometry.type === "LineString") {
        const geoProperties = {
          strokeColor: "#FFF",
          strokeOpacity: 1,
          strokeWeight: 3,
          zIndex: 1
        };

        if (properties.stroke) geoProperties.strokeColor = properties.stroke;
        if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
        if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];

        const location = geometry.coordinates.map(e => ({ lng: e[0], lat: e[1] }));

        options.properties = { ...geoProperties, others: { ...properties } };
        options.location = location;
        options.type = GEO_SHAPE_TYPE.POLYLINE;
      } else if (geometry.type === "Circle") {
        const geoProperties = {
          strokeColor: '#FFF',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03FF6D33',
          fillOpacity: 1,
          zIndex: 1
        };

        if (properties.stroke) geoProperties.strokeColor = properties.stroke;
        if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
        if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];
        if (properties.fill) geoProperties.fillColor = properties.fill;
        if (properties["fill-opacity"]) geoProperties.fillOpacity = properties["fill-opacity"];

        const location = {
          lng: geometry.coordinates[0],
          lat: geometry.coordinates[1]
        }
        options.location = [location];

        options.properties = { ...geoProperties, others: { ...properties } };
        options.location = location;
        options.type = GEO_SHAPE_TYPE.CIRCLE;
      } else if (geometry.type === "Rectangle") {
        const geoProperties = {
          strokeColor: '#FFF',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03FF6D33',
          fillOpacity: 1,
          zIndex: 1
        };

        if (properties.stroke) geoProperties.strokeColor = properties.stroke;
        if (properties["stroke-opacity"]) geoProperties.strokeOpacity = properties["stroke-opacity"];
        if (properties["stroke-width"]) geoProperties.strokeWeight = properties["stroke-width"];
        if (properties.fill) geoProperties.fillColor = properties.fill;
        if (properties["fill-opacity"]) geoProperties.fillOpacity = properties["fill-opacity"];

        const location = geometry.coordinates[0].map(e => ({ lng: e[0], lat: e[1] }));

        options.properties = { ...geoProperties, others: { ...properties } };
        options.location = location;
        options.type = GEO_SHAPE_TYPE.RECTANGLE;
      } else {
        store.dispatch(toastError('Could not recognize content.'));
      }

      const shape = shapeObj.createShape({
        id: shapeId,
        ...options
      });
      if (!shape || !options.type) return;

      shape.type = options.type;
      shape.name = properties.name || properties.FIELD_NAME || properties.FieldName || "Untitled";
      if (properties.folder_name) {
        shape.folder_name = properties.folder_name || "Untitled";
      }

      if (shape.name && shape.name.length > 0 && this.title.name === "Untitled") {
        const title = this.title;
        title["name"] = shape.name;

        this.drawingTools.emit("title_save", { title: this.title });
      }
      this.drawingTools.addShapeToList(shape);
      this.drawingTools._addShapeEventListener(shape);
    }
    // add individual geometry 
    const addGeometry = (geoData) => {
      if (geoData.geometry && Array.isArray(geoData.geometry.geometries)) {
        for (const item of geoData.geometry.geometries) addShapes({ geometry: item || {}, properties: geoData.properties || {} });
      } else addShapes(geoData);
    }

    if (data.features && Array.isArray(data.features)) for (const item of data.features) addGeometry(item)
    else addGeometry(data);

    await this.drawingTools.showShapes();
    await this.drawingTools.setBounds(this.drawingTools.editableShapeGroupId);
    return this;
  }

  addFolderName(doc, geoJSON) {
    const folders = doc.getElementsByTagName("Folder");
    if (folders.length === 0) return geoJSON;
    let { features } = geoJSON;
    const kmlFileInfo = [];
    for (var i = 0; i < folders.length; i++) {
      const folderName = folders[i].children[0].textContent;
      let folderId = null;
      var geoNames = [];
      for (var l = 0; l < folders[i].children.length; l++) {
        if (folders[i].children[l].children[0]) {
          geoNames.push({
            name: folders[i].children[l].children[0].innerHTML,
            folderId: folders[i].children[l].children[2].innerHTML,
            folderName
          })
        }
      }
      kmlFileInfo.push({ folderName, folderId, count: folders[i].children.length > 1 ? folders[i].children.length - 1 : 0, geoNames });
    }
    for (let k = 0; k < kmlFileInfo.length; k++) {
      for (let m = 0; m < kmlFileInfo[k].geoNames.length; m++) {
        features.map(geo => {
          if (geo.properties.name === kmlFileInfo[k].geoNames[m].name) {
            return geo.properties["folder_name"] = kmlFileInfo[k].folderName;
          } else {
            return geo;
          }
        });
      }
    }
    return geoJSON;
  }

  structureShpGeoJSON(data) {
    let geoShapJson = {
      features: [],
      type: "FeatureCollection"
    }
    let shapes = [];
    for (const item of data) {
      let feature = item.features;
      for (const shape in feature) {
        let properties = feature[shape]['properties'];
        properties['folder_name'] = properties.FARM_NAME;
        properties['name'] = properties.FIELD_NAME;
      }
      shapes.push(...feature);
    }
    geoShapJson.features = [...shapes];
    return geoShapJson;
  }

}